export default __webpack_public_path__ + "static/media/pan-right.1d6ff4e4.svg";